import React from 'react';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper'

import * as toasterTypes from '../constants/ActionTypes';
// import Loading from './components/Loading'

const locationHelper = locationHelperBuilder({})

const userIsAuthenticatedDefaults = {
  authenticatedSelector: state => state.loginUser.data !== null,
  authenticatingSelector: state => state.loginUser.isLoading,
  wrapperDisplayName: 'UserIsAuthenticated'
}

export const userIsAuthenticated = connectedAuthWrapper(userIsAuthenticatedDefaults)

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  ...userIsAuthenticatedDefaults,
  // AuthenticatingComponent: <div>Logging you in...</div>,
  redirectPath: '/login'
})

const userIsNotAuthenticatedDefaults = {
  // Want to redirect the user when they are done loading and authenticated
  authenticatedSelector: state => state.loginUser.data === null,
  wrapperDisplayName: 'UserIsNotAuthenticated'
}

export const userIsNotAuthenticated = connectedAuthWrapper(userIsNotAuthenticatedDefaults)

export const userIsNotAuthenticatedRedir = connectedRouterRedirect({
  ...userIsNotAuthenticatedDefaults,
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || 'dashboard',
  allowRedirectBack: false
})

export const userIsSuperAdminRedir = connectedRouterRedirect({
  redirectPath: '/dashboard/-1',
  allowRedirectBack: false,
  authenticatedSelector: state => state.loginUser && state.loginUser.data !== null && state.loginUser.data.role_id == 1,
  // // predicate: loginUser => loginUser,
  // redirectAction: (newLoc) => (dispatch) => {
  //   dispatch(replace(newLoc));
  //   dispatch({ type: toasterTypes.DISPLAY_WARNING, message: 'Sorry!!! You are not Authorised to view requested information' });
  // },
  wrapperDisplayName: 'UserIsSuperAdmin'
})

export const userIsBoardAdminRedir = connectedRouterRedirect({
  redirectPath: '/dashboard/-1',
  allowRedirectBack: false,
  authenticatedSelector: state => state.loginUser && state.loginUser.data !== null && state.loginUser.data.role_id == 2,
  // predicate: loginUser => loginUser,
  wrapperDisplayName: 'UserIsBoardAdmin'
})

export const userIsCommitteeAdminRedir = connectedRouterRedirect({
  redirectPath: '/dashboard/-1',
  allowRedirectBack: false,
  authenticatedSelector: state => state.loginUser && state.loginUser.data !== null && state.loginUser.data.role_id == 3,
  // predicate: loginUser => loginUser,
  wrapperDisplayName: 'UserIsCommitteeAdmin'
})

export const userIsCheckerAdminRedir = connectedRouterRedirect({
  redirectPath: '/dashboard/-1',
  allowRedirectBack: false,
  authenticatedSelector: state => state.loginUser && state.loginUser.data !== null && state.loginUser.data.role_id == 5,
  // predicate: loginUser => loginUser,
  wrapperDisplayName: 'UserIsCheckerAdmin'
})



// WEBPACK FOOTER //
// ./app/auth.js